module.exports = __webpack_public_path__ + "img/sec03-06.4c2e358c.png";